export default "__VITE_ASSET__B$xTDD2q__"